import React from "react";
import { Reveal, Kicker, Tag, WfButton, ImageWithCredit } from "@/components/site/primitives";
import { PROGRAMS } from "@/content/worldFarmers";
import { scrollToId } from "@/lib/scrollTo";

export const Programs = () => {
  const { flats, mentorship } = PROGRAMS;
  const go = (id) => (e) => { e.preventDefault(); scrollToId(id); };
  return (
    <section id="programs" aria-labelledby="programs-heading" className="wf-section bg-[var(--wf-paper)]">
      <div className="wf-container">
        <Reveal className="max-w-2xl">
          <Kicker>Hands-on, practical, community-centered</Kicker>
          <h2 id="programs-heading" className="mt-3 font-serif text-3xl font-semibold text-[var(--wf-ink)] sm:text-4xl">
            Our programs
          </h2>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          {/* Left: Flats narrative */}
          <Reveal className="lg:col-span-5">
            <div className="flex h-full flex-col overflow-hidden rounded-sm border border-[var(--wf-border)] bg-[var(--wf-cream)] shadow-[var(--wf-shadow-sm)]">
              <ImageWithCredit src={flats.image} alt={flats.alt} className="aspect-[16/10]" />
              <div className="flex flex-1 flex-col p-6">
                <Tag className="w-fit">{flats.badge}</Tag>
                <h3 className="mt-3 font-serif text-2xl font-semibold text-[var(--wf-ink)]">{flats.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-6 text-muted-foreground">{flats.body}</p>
                <div className="mt-5">
                  <WfButton as="a" href="#gallery" onClick={go("gallery")} variant="secondary" withArrow data-testid="programs-learn-more-button">
                    See the farm
                  </WfButton>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Right: 5-phase stepper */}
          <div className="lg:col-span-7">
            <Reveal>
              <div className="flex items-center gap-3">
                <Tag tone="green" className="w-fit">{mentorship.badge}</Tag>
              </div>
              <h3 className="mt-3 font-serif text-2xl font-semibold text-[var(--wf-ink)] sm:text-3xl">{mentorship.title}</h3>
              <p className="mt-3 max-w-[56ch] text-sm leading-6 text-muted-foreground">{mentorship.body}</p>
            </Reveal>

            <ol className="mt-7 space-y-3">
              {mentorship.phases.map((p, idx) => (
                <Reveal as="li" key={p.n} delay={0.05 * idx}>
                  <div
                    data-testid={`program-phase-${p.n}`}
                    className="group flex items-start gap-4 rounded-sm border border-[var(--wf-border)] bg-[var(--wf-paper)] p-4 shadow-[var(--wf-shadow-sm)] transition-[box-shadow,transform] duration-300 hover:shadow-[var(--wf-shadow)] motion-safe:hover:-translate-y-0.5"
                    style={{ marginLeft: `${idx * 8}px` }}
                  >
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--wf-maroon)] font-serif text-lg font-semibold text-[var(--wf-paper)]">
                      {p.n}
                    </span>
                    <div>
                      <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[var(--wf-green-text)]">Phase {p.n}</p>
                      <h4 className="font-serif text-lg font-semibold text-[var(--wf-ink)]">{p.title}</h4>
                      <p className="mt-1 text-sm leading-6 text-muted-foreground">{p.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};
